/* MUSE · The Library · Bundle builder
   Fills one fragrance per slot, then adds the fixed-price bundle variant to the cart
   with line item properties. Price is set on the bundle variant in Shopify (server-side);
   nothing here can change what the customer pays. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__lbbReady) return;
    root.__lbbReady = true;

    var cfgEl = root.querySelector('[data-lbb-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[lbb] config', e); return; }

    var bundle = cfg.bundle || {};
    var slots = (bundle.slots || []).map(function (s) { return { format: s.format, size: s.size, pick: null }; });
    if (!slots.length) return;
    var frags = (cfg.fragrances || []).filter(function (f) {
      return slots.some(function (s) { return f.v && f.v[s.format]; });
    });
    var byHandle = {};
    frags.forEach(function (f) { byHandle[f.h] = f; });

    // label per slot: "Travel Spray 1/2/3" when a format repeats, else "Room Spray"
    var formatCounts = {};
    slots.forEach(function (s) { formatCounts[s.format] = (formatCounts[s.format] || 0) + 1; });
    var seen = {};
    slots.forEach(function (s) {
      seen[s.format] = (seen[s.format] || 0) + 1;
      s.label = formatCounts[s.format] > 1 ? s.format + ' ' + seen[s.format] : s.format;
    });

    var els = {
      grid: root.querySelector('[data-lbb-grid]'),
      search: root.querySelector('[data-lbb-search]'),
      chips: Array.prototype.slice.call(root.querySelectorAll('.lbb-chip')),
      more: root.querySelector('[data-lbb-more]'),
      empty: root.querySelector('[data-lbb-empty]'),
      status: root.querySelector('[data-lbb-status]'),
      prompt: root.querySelector('[data-lbb-prompt]'),
      slots: root.querySelector('[data-lbb-slots]'),
      add: root.querySelector('[data-lbb-add]'),
      helper: root.querySelector('[data-lbb-helper]'),
      msg: root.querySelector('[data-lbb-msg]'),
      form: root.querySelector('[data-lbb-form]'),
      done: root.querySelector('[data-lbb-done]'),
      again: root.querySelector('[data-lbb-again]'),
      bar: root.querySelector('[data-lbb-bar]'),
      barCount: root.querySelector('[data-lbb-bar-count]'),
      barAdd: root.querySelector('[data-lbb-bar-add]'),
      summary: root.querySelector('.lbb-summary')
    };

    var PAGE = 24;
    var state = { active: 0, family: 'all', q: '', limit: PAGE, busy: false };

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function filledCount() { return slots.filter(function (s) { return s.pick; }).length; }
    function firstEmpty(from) {
      for (var i = 0; i < slots.length; i++) {
        var k = ((from || 0) + i) % slots.length;
        if (!slots[k].pick) return k;
      }
      return -1;
    }
    function activeFormat() { return slots[state.active] ? slots[state.active].format : slots[0].format; }
    function variantFor(f, format) { return f && f.v ? f.v[format] : null; }
    function track(name, extra) {
      try {
        window.dataLayer = window.dataLayer || [];
        var o = { event: name, bundle_code: bundle.code, bundle_title: bundle.title, bundle_price: bundle.price / 100 };
        for (var k in extra) o[k] = extra[k];
        window.dataLayer.push(o);
      } catch (e) {}
    }

    /* ---------- slots ---------- */
    function renderSlots() {
      var html = slots.map(function (s, i) {
        var f = s.pick ? byHandle[s.pick] : null;
        var cls = 'lbb-slot' + (i === state.active ? ' is-active' : '') + (f ? ' is-filled' : '');
        return '<li>' +
          '<div class="' + cls + '" role="button" tabindex="0" data-slot="' + i + '" aria-pressed="' + (i === state.active) + '"' +
          ' aria-label="' + esc(s.label) + ': ' + (f ? esc(f.t) + '. Select to change.' : 'choose a fragrance') + '">' +
          '<span class="lbb-slot__num">' + (i < 9 ? '0' : '') + (i + 1) + '</span>' +
          '<span><span class="lbb-slot__fmt">' + esc(s.format) + (s.size ? ' &middot; ' + esc(s.size) : '') + '</span>' +
          '<span class="lbb-slot__val">' + (f ? esc(f.t) : (i === state.active ? 'Choose below' : 'Choose a fragrance')) + '</span></span>' +
          '<button type="button" class="lbb-slot__clear" data-clear="' + i + '" aria-label="Remove ' + (f ? esc(f.t) : '') + ' from ' + esc(s.label) + '">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4"/></svg></button>' +
          '</div></li>';
      }).join('');
      els.slots.innerHTML = html;
      var n = filledCount(), total = slots.length, left = total - n;
      var complete = left === 0;
      var canBuy = complete && bundle.available !== false && !state.busy;
      els.add.disabled = !canBuy;
      els.barAdd.disabled = !canBuy;
      els.helper.textContent = !bundle.available ? '' : complete ? 'Your selection is complete.' : 'Choose ' + left + ' more fragrance' + (left === 1 ? '' : 's') + '.';
      els.barCount.textContent = n + ' of ' + total + ' chosen';
      var s = slots[state.active];
      els.prompt.textContent = complete ? 'All set. Select a slot to change it.' : 'Now choosing: ' + s.label + (s.size ? ', ' + s.size : '');
    }

    /* ---------- fragrance grid ---------- */
    function matches(f) {
      if (state.family !== 'all' && (f.fam || '').indexOf(state.family) === -1) return false;
      if (state.q) {
        var hay = (f.t + ' ' + f.n + ' ' + f.fl).toLowerCase();
        if (hay.indexOf(state.q) === -1) return false;
      }
      return true;
    }
    function renderGrid() {
      var fmt = activeFormat();
      var list = frags.filter(matches);
      var shown = list.slice(0, state.limit);
      var counts = {};
      slots.forEach(function (s) { if (s.pick) counts[s.pick] = (counts[s.pick] || 0) + 1; });
      els.grid.innerHTML = shown.map(function (f) {
        var v = variantFor(f, fmt);
        var ok = v && v.a;
        var c = counts[f.h] || 0;
        var badge = f.nw ? '<span class="lbb-badge">New</span>' : (f.tr ? '<span class="lbb-badge">Trending</span>' : '');
        return '<button type="button" role="listitem" class="lbb-frag' + (c ? ' is-picked' : '') + '" data-h="' + esc(f.h) + '"' +
          (ok ? '' : ' aria-disabled="true"') +
          ' aria-label="' + esc(f.t) + (f.n ? ', ' + esc(f.n) : '') + (ok ? '. Add as ' + esc(slots[state.active].label) : '. ' + esc(fmt) + ' unavailable') + '">' +
          '<span class="lbb-frag__count" aria-hidden="true">' + (c ? '&times;' + c : '') + '</span>' +
          (f.fl ? '<span class="lbb-frag__fam">' + esc(f.fl) + '</span>' : '') +
          '<span class="lbb-frag__name">' + esc(f.t) + badge + '</span>' +
          (f.n ? '<span class="lbb-frag__notes">' + esc(f.n) + '</span>' : '<span class="lbb-frag__notes"></span>') +
          '<span class="lbb-frag__add">' + (ok ? 'Add' : 'Unavailable') + '</span>' +
          '</button>';
      }).join('');
      els.empty.hidden = list.length !== 0;
      els.more.hidden = list.length <= state.limit;
      var filtered = state.q || state.family !== 'all';
      els.status.innerHTML = filtered && list.length ? '<b>' + list.length + '</b> matching fragrance' + (list.length === 1 ? '' : 's') : '';
    }

    function renderAll() { renderSlots(); renderGrid(); }

    function pick(handle) {
      var f = byHandle[handle];
      if (!f) return;
      var s = slots[state.active];
      var v = variantFor(f, s.format);
      if (!v || !v.a) return;
      s.pick = handle;
      track('muse_bundle_select', { slot: s.label, fragrance: f.t });
      var next = firstEmpty(state.active + 1);
      if (next !== -1) state.active = next;
      els.msg.hidden = true;
      renderAll();
      if (filledCount() === slots.length && window.matchMedia('(max-width: 989px)').matches && els.summary) {
        els.summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* ---------- add to cart ---------- */
    function buildProperties() {
      var props = {};
      var skus = [], ids = [];
      slots.forEach(function (s) {
        var f = byHandle[s.pick];
        var v = variantFor(f, s.format);
        props[s.label] = f.t;
        skus.push((v && v.sku) || '');
        ids.push((v && v.id) || '');
      });
      props._bundle = bundle.code;
      props._component_skus = skus.join(' | ');
      props._component_variant_ids = ids.join(' | ');
      return props;
    }

    function addToCart() {
      if (state.busy || filledCount() !== slots.length) return;
      state.busy = true;
      els.add.setAttribute('aria-busy', 'true');
      renderSlots();
      var props = buildProperties();
      var body = { items: [{ id: bundle.variantId, quantity: 1, properties: props }] };
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          track('muse_bundle_add', { selections: Object.keys(props).filter(function (k) { return k.charAt(0) !== '_'; }).map(function (k) { return props[k]; }).join(', ') });
          els.form.hidden = true;
          els.done.classList.add('is-on');
          els.bar.classList.remove('is-on');
          // Let the Horizon cart drawer, bubble and cart items refresh
          import('@theme/events').then(function (m) {
            document.dispatchEvent(new m.CartAddEvent(cart, 'lb-bundle-builder', {
              source: 'lb-bundle-builder', itemCount: 1, productId: String(bundle.productId), variantId: String(bundle.variantId)
            }));
          }).catch(function () {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'lb-bundle-builder', data: { source: 'lb-bundle-builder' } } }));
          });
        })
        .catch(function (err) {
          els.msg.hidden = false;
          els.msg.classList.add('is-error');
          els.msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        })
        .then(function () {
          state.busy = false;
          els.add.removeAttribute('aria-busy');
          renderSlots();
        });
    }

    function reset() {
      slots.forEach(function (s) { s.pick = null; });
      state.active = 0;
      els.form.hidden = false;
      els.done.classList.remove('is-on');
      renderAll();
      root.querySelector('.lbb-build').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---------- events ---------- */
    els.grid.addEventListener('click', function (e) {
      var b = e.target.closest('.lbb-frag');
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      pick(b.getAttribute('data-h'));
    });
    els.slots.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-clear]');
      if (clr) {
        e.stopPropagation();
        var ci = +clr.getAttribute('data-clear');
        slots[ci].pick = null; state.active = ci; renderAll(); return;
      }
      var s = e.target.closest('[data-slot]');
      if (!s) return;
      state.active = +s.getAttribute('data-slot');
      renderAll();
      if (window.matchMedia('(max-width: 989px)').matches) els.search.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    els.slots.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-slot]')) { e.preventDefault(); e.target.click(); }
    });
    var t;
    els.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = els.search.value.trim().toLowerCase(); state.limit = PAGE; renderGrid(); }, 120);
    });
    els.chips.forEach(function (c) {
      c.addEventListener('click', function () {
        state.family = c.getAttribute('data-family');
        els.chips.forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
        state.limit = PAGE; renderGrid();
      });
    });
    els.more.addEventListener('click', function () { state.limit += PAGE; renderGrid(); });
    els.add.addEventListener('click', addToCart);
    els.barAdd.addEventListener('click', addToCart);
    els.again.addEventListener('click', reset);
    var viewCart = root.querySelector('[data-lbb-viewcart]');
    if (viewCart) viewCart.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
    });

    // Mobile sticky bar appears once the summary scrolls out of view
    if ('IntersectionObserver' in window && els.summary && els.bar) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && !els.done.classList.contains('is-on');
        els.bar.classList.toggle('is-on', off);
        els.bar.setAttribute('aria-hidden', String(!off));
        els.barAdd.tabIndex = off ? 0 : -1;
      }, { threshold: 0 }).observe(els.summary);
    }

    // Optional prefill: ?fragrance=handle&vessel=Reed%20Diffuser ('format' is reserved by Shopify)
    try {
      var params = new URLSearchParams(location.search);
      var pre = params.get('fragrance');
      var preFmt = params.get('vessel');
      if (pre && byHandle[pre]) {
        var idx = 0;
        if (preFmt) {
          for (var i = 0; i < slots.length; i++) { if (slots[i].format.toLowerCase() === preFmt.toLowerCase()) { idx = i; break; } }
        }
        var preV = variantFor(byHandle[pre], slots[idx].format);
        if (preV && preV.a) { state.active = idx; pick(pre); }
      }
    } catch (e) {}

    if (!bundle.available) { els.add.disabled = true; }
    renderAll();
    track('muse_bundle_view', {});
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.lbb-builder'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
